import { QrCodeTwoTone } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Widget } from '../../../shared';

export const StartRegistrationInfo: FC = () => {
    const { t } = useTranslation();

    return (
        <Widget>
            <Stack spacing={2} alignItems="center" justifyContent="center">
                <QrCodeTwoTone color="primary" />
                <Typography variant="h6">{t('scanCode')}</Typography>
                {t('scanDescription')}
            </Stack>
        </Widget>
    );
};
